<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h3>
                    Accommodation Price Discount
                </h3>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <form class="form" v-on:submit.prevent="handleDiscount">
                    <fieldset>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-wrap">
                                    <div>
                                        <label for="start-date"> Booking Start Date</label>
                                        <input id="start-date" type="date" class="m-0" v-model="discount_fileds.booking_start_date" required>
                                        <small class="text-danger" v-if="validation.booking_start_date">Please prove a valid start date</small>
                                    </div> 
                                    <div>
                                        <label for="start-date"> Booking End Date</label>
                                        <input id="start-date" type="date" class="m-0" v-model="discount_fileds.booking_end_date" required>
                                        <small class="text-danger" v-if="validation.booking_end_date">Please prove a valid end date</small>
                                    </div> 
                                    <div>
                                        <label for="percentage">Is percentage discount?</label>
                                        <label class="switch">
                                            <input id="penalty_type" type="checkbox" v-model="discount_fileds.percent_discount">
                                            <span class="switch__slider"></span>
                                        </label>
                                    </div>
                                    <div>
                                        <label for="discount_price"> Discount Price </label>
                                        <input id="discount_price" type="number" step="0.01" placeholder="Discount Price"  v-model="discount_fileds.discount_price" required>
                                    </div>
                                    <div class="mt-4">
                                        <div class="form-submit-inline">
                                            <button type="submit" class="button">
                                                <span> {{ (this.discount_fileds.flag == 'add' ? 'Add' : 'Edit') }} Discount </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
        <hr>
        <div class="row" v-if="this.multiple_price_ids.length == 0">
            <div class="col-md-12">
                <table class="table" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Bookiing Start Date</th>
                            <th>Booking End Date</th>
                            <th>Discounted Price</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="accomodation_price_discount.length > 0 ">
                            <template v-for="discounts in accomodation_price_discount">
                                <tr :key="discounts.id">
                                    <td scope="row"> {{ discounts.booking_start_date | formatDate }}</td>
                                    <td scope="row"> {{ discounts.booking_end_date | formatDate }}</td>
                                    <td scope="row"> 
                                        <template v-if="discounts.percent_discount">
                                           {{discounts.discount_price }}%
                                        </template>
                                        <template v-else> 
                                            {{ accomodationPriceID.currency.symbol }}{{ discounts.discount_price }}
                                        </template>
                                    </td>
                                    <td class="table-action">
                                        <a class="button p-2" @click="editDiscount(discounts)">Edit</a>
                                    </td>
                                    <td class="table-action">
                                        <a class="button p-2" @click="deleteDiscount(discounts.id)">Delete</a>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="5" class="text-center"> 
                                    <h4>No data available.</h4>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccomodationPriceDiscount',
    props: {
        multiple_price_ids:Array,
        accomodationPriceID:Object
    },
    created() {
        this.getDiscounts()  
    },
    data() {
        return {
            discount_fileds: {
                flag:'add',
                booking_start_date: null,
                booking_end_date: null,
                percent_discount: false,
                discount_price:0
            },
            validation: {
                booking_start_date:false,
                booking_end_date:false,
            },
            selected_discount:{},
            selectedAccomodationDiscountId:null,
            accomodation_price_discount:[]
        }
    },
    methods: {
        getDiscounts() {
            if (this.multiple_price_ids.length == 0) {
                this.$store.dispatch('setLoadStatus')
                fetch(`${this.$api}accommodation/room/price-discount/${this.accomodationPriceID.id}`, {
                    headers:{
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.status) {
                        this.accomodation_price_discount = response.data
                    }
                    this.$store.dispatch('setLoadStatus')
                });
            }
        },
        validateDates() {
            return new Promise((resolve, reject) => {
                let validate_date = this.isDateRangeValid(this.discount_fileds.booking_start_date, this.discount_fileds.booking_end_date, this.accomodation_price_discount)
                if (validate_date) {
                    this.validation = {
                        booking_start_date:false,
                        booking_end_date:false,
                    }
                    resolve(true)
                } else {
                    this.validation = {
                        booking_start_date:true,
                        booking_end_date:true,
                    }
                    reject()
                }
            })
        },
        handleDiscount() {

            this.validateDates()
                .then((response) => {
                    this.$store.dispatch('setLoadStatus')
                    let post_url = `${this.$api}accommodation/room/price-discount/${this.accomodationPriceID.id}/handle` 
                    if (this.multiple_price_ids.length > 1) {
                        this.discount_fileds.multiple_price_ids = this.multiple_price_ids
                        post_url = `${this.$api}accommodation/room/handle-multiple-prices-discount`
                    }
                    fetch(post_url, {
                        method: 'post',
                        body: JSON.stringify(this.discount_fileds),
                        headers:{
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                        }
                    })
                    .then(res => res.json())
                    .then(response => {
                        if (response.status) {
                            
                            this.discount_fileds = {
                                flag:'add',
                                booking_start_date: null,
                                booking_end_date: null,
                                percent_discount: false,
                                discount_price:0
                            }
        
                            this.$notify({
                                type: 'success',
                                title: response.message
                            });
        
                            if (this.multiple_price_ids.length > 1) {
                                this.$emit('handleDiscountModal',false)
                            }
        
                        } else {
                            this.$notify({
                                type: 'error',
                                title: response.message
                            });
                        }
                        this.getDiscounts()
                        this.$store.dispatch('setLoadStatus')
                    })
                })
        },
        editDiscount(discount){
            this.discount_fileds = discount
            this.discount_fileds.flag = 'edit'
        },
        deleteDiscount(discount_id){
            this.$dialog
                .confirm(`Are you sure you want to delete this Price Discount ?`)
                .then(() => {
                    this.$store.dispatch('setLoadStatus')
                    fetch(`${this.$api}accommodation/room/price-discount/${this.accomodationPriceID.id}/delete-discount/${discount_id}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': localStorage.getItem('token')
                        }
                    })
                    .then(res => res.json())
                    .then(response => {
                        this.errors = response.errors
                        if(response.status) {
                            this.$notify({
                                type: 'success',
                                title: response.message
                            });
                            this.getDiscounts()
                        } else if (response.errors) {
                            this.$notify({
                                type: 'error',
                                title: response.message
                            });
                        } else {
                            this.$notify({
                                type: 'error',
                                title: response.Error
                            });
                        }
                        this.$store.dispatch('setLoadStatus')
                    });
                }).catch((error) => {
                    console.log(error);
                    // this.$store.dispatch('setLoadStatus')
                    console.log('Clicked on cancel');
                });
        },
        doRangesOverlap(start1, end1, start2, end2) {
            return start1 <= end2 && start2 <= end1;
        },
        validateDateRange(selectedStart, selectedEnd, existingRanges) {
            for (const range of existingRanges) {
                if (this.doRangesOverlap(selectedStart, selectedEnd, range.start, range.end)) {
                    return false; // Overlap found
                }
            }
            return true; // No overlap
        },
        isDateRangeValid(selectedStart, selectedEnd, existingRanges) {
            // Ensure selectedStart is before or equal to selectedEnd
            if (selectedStart > selectedEnd) {
                return false;
            }

            // Convert date strings to Date objects if they're not already
            const start = selectedStart instanceof Date ? selectedStart : new Date(selectedStart);
            const end = selectedEnd instanceof Date ? selectedEnd : new Date(selectedEnd);

            // Convert existing ranges to Date objects if they're not already
            const formattedExistingRanges = existingRanges.map(range => ({
                start: range.booking_start_date instanceof Date ? range.booking_start_date : new Date(range.booking_start_date),
                end: range.booking_end_date instanceof Date ? range.booking_end_date : new Date(range.booking_end_date)
            }));

            return this.validateDateRange(start, end, formattedExistingRanges);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>